// mds-dojo — dijit/Viewport — FAITHFUL port of references/dijit/Viewport.js.
// Utility singleton to watch for viewport resizes (Viewport.on("resize", cb)),
// avoiding duplicate notifications. IE8 zoom + iOS virtual-keyboard branches dropped
// (modern evergreen); getEffectiveBox = getBox (no iOS keyboard estimation).
import Evented from '../dojo/Evented';
import on from '../dojo/on';
import ready from '../dojo/ready';
import winUtils from '../dojo/window';

const Viewport: any = new (Evented as any)();

ready(function () {
  let oldBox = winUtils.getBox();
  Viewport._rlh = on(window, 'resize', function () {
    const newBox = winUtils.getBox();
    if (oldBox.h == newBox.h && oldBox.w == newBox.w) { return; }
    oldBox = newBox;
    Viewport.emit('resize');
  });
});

Viewport.getEffectiveBox = function (doc?: any): any {
  // Size of the viewport (mobile keyboard estimation omitted).
  return winUtils.getBox(doc);
};

export default Viewport;
